export const selectFormBundlesAfterSubmitSchema = ({ formBundlesAfterSubmitSchema }) =>
  formBundlesAfterSubmitSchema;
